interface CourseIconProps {
  className?: string;
}

export default function CourseIcon({ className }: CourseIconProps) {
  return (
    <svg
      width="28"
      height="30"
      viewBox="0 0 28 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M21.6232 23.8216C21.3096 24.7821 20.7586 25.6478 20.0212 26.3386C18.9247 27.3661 17.2327
        27.8191 13.8502 28.7251C10.4677 29.6311 8.77569 30.0856 7.31319 29.7436C6.1576 29.4741
        5.10786 28.8681 4.29669 28.0021C3.26919 26.9056 2.81469 25.2136 1.90869 21.8311L1.13319
        18.9331C0.225687 15.5506 -0.227314 13.8586 0.113186 12.3961C0.383055 11.2403 0.98963
        10.1906 1.85619 9.37958C2.95269 8.35208 4.64469 7.89908 8.02719 6.99158C8.66619 6.82058
        9.24669 6.66458 9.77469 6.52808L9.40869 7.88708L8.63319 10.7851C7.72569 14.1676 7.27269
        15.8581 7.61319 17.3221C7.88305 18.4778 8.48963 19.5276 9.35619 20.3386C10.4527 21.3661
        12.1447 21.8191 15.5272 22.7266C18.5752 23.5426 20.2507 23.9911 21.6232 23.8216Z"
        className="fill-primary-100"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.3151 13.0725L25.5381 15.9705C24.6306 19.353 24.1776 21.045 23.1501 22.1415C22.3394
        23.0072 21.2902 23.6133 20.1352 23.883C19.9897 23.9175 19.8427 23.943 19.6927 23.961C18.3202
        24.1305 16.6447 23.682 13.5967 22.866C10.2143 21.9585 8.52228 21.5055 7.42579 20.478C6.55979
        19.6668 5.95375 18.6171 5.6843 17.4615C5.3423 15.9975 5.7953 14.307 6.70279 10.9245L7.47829
        8.02649L7.84428 6.66899C8.52678 4.16999 8.98577 2.79449 9.86626 1.85399C10.6772 0.988789
        11.7264 0.383301 12.8812 0.11399C14.3452 -0.22801 16.0372 0.22499 19.4212 1.13249C22.8021
        2.03849 24.4941 2.49149 25.5906 3.51749C26.4569 4.32907 27.0629 5.37937 27.3321
        6.53549C27.6741 7.99949 27.2211 9.68999 26.3151 13.0725ZM11.6482 11.7075C11.6865 11.5648
        11.7526 11.431 11.8426 11.3138C11.9326 11.1966 12.0448 11.0982 12.1728 11.0244C12.3008
        10.9506 12.4421 10.9027 12.5886 10.8835C12.7352 10.8643 12.884 10.8741 13.0267 10.9125L20.2717
        12.855C20.4182 12.8897 20.5562 12.9535 20.6775 13.0426C20.7989 13.1316 20.9012 13.2441 20.9783
        13.3734C21.0554 13.5027 21.1058 13.6461 21.1265 13.7953C21.1471 13.9444 21.1376 14.0961 21.0986
        14.2415C21.0595 14.3869 20.9917 14.523 20.8991 14.6417C20.8065 14.7604 20.691 14.8593 20.5595
        14.9325C20.428 15.0057 20.2831 15.0518 20.1334 15.0681C19.9837 15.0843 19.8323 15.0703 19.6882
        15.027L12.4432 13.086C12.1553 13.0087 11.9099 12.8202 11.7608 12.562C11.6117 12.3038 11.5713
        11.9955 11.6482 11.7075ZM10.4843 16.0545C10.5616 15.7666 10.7501 15.5211 11.0082 15.3721C11.2664
        15.223 11.5732 15.1825 11.8612 15.2595L16.2082 16.425C16.3554 16.459 16.4942 16.5222 16.6164
        16.611C16.7386 16.6998 16.8417 16.8123 16.9195 16.9417C16.9973 17.0712 17.0482 17.215 17.0693
        17.3646C17.0903 17.5142 17.081 17.6664 17.0419 17.8124C17.0028 17.9583 16.9347 18.0948 16.8417
        18.2138C16.7487 18.3328 16.6327 18.4319 16.5006 18.5051C16.3685 18.5784 16.223 18.6242 16.0727
        18.64C15.9225 18.6558 15.7707 18.6412 15.6262 18.597L11.2793 17.433C11.1365 17.3947 11.0027
        17.3287 10.8855 17.2387C10.7683 17.1487 10.67 17.0365 10.5962 16.9084C10.5224 16.7804 10.4745
        16.6391 10.4553 16.4926C10.4361 16.3461 10.4459 16.1972 10.4843 16.0545Z"
        className="fill-primary-400"
      />
    </svg>
  );
}
